import Highcharts from 'highcharts';

export const figure35 = { 
chart: {
zoomType: 'xy',
animation: false,
marginTop: 50,
plotBackgroundColor: null,
plotBorderWidth: null,
plotShadow: false,
type: 'column',
backgroundColor: 'rgba(255, 255, 255, 0.0)',
style: {
fontFamily: 'Montserrat'
}
},

credits: {
enabled: false
},
title: {
text: null
},
subtitle: {
text: null
},

plotOptions: {
series: {
borderWidth: 0,
stacking: 'normal',
}
// line: {
//   stacking: 'normal',
//   // shared options for all line series
//
},

exporting: {
enabled: false
},


xAxis: [{
categories: [ "2000", "2001", "2002" , "2003", "2004", "2005", "2006", "2007", "2008", "2009", "2010", "2011", "2012", "2013", "2014", "2015", "2016", "2017", "2018", "2019", "2020", "2021"],
lineColor: "#d7d7d7",
tickColor: "#d7d7d7",
tickLength: 16,
labels: {
style: {
fontWeight: 'normal',
color: '#999999',
fontSize: '12px',
}
},
}],
yAxis: [{
labels: {
style: {
fontWeight: 'normal',
color: '#999999',
fontSize: '12px'
},
},
max: 4500,
min: 0,
tickInterval: 500,
format: '{value.dollar}$',
gridLineWidth: 2,
floor: 0,
title: {
text: "",
style: {
color: Highcharts.getOptions().colors[1]
}
}
}],
tooltip: {
shared: true,
useHTML: true,
hideDelay: 500,
backgroundColor: null,
borderWidth: 0,
shadow: false,
// //headerFormat: '<div>{point.key}</div>',
// valuePrefix: '$',
style: {
padding: 0
}
},
legend: {
enabled: false,
},

series: [
{
	type: 'column',
	name: 'المناطق النامية',
	color: '#ed7d31',
	data: [88.9, 63.1, 58.8, 63.1, 62.3, 93.7, 82.4, 111.5, 130.1, 168.7, 76.6, 103.2, 81.6, 65.6, 48.2, 37.4, 51.2, 77.0, 65.6, 53.9, 0.0, 0.0]

},
{
type: 'column',
name: 'المناطق المتقدمة',
color: '#5b9bd5',
borderColor: '#a4a4a4',
borderWidth: 1,
data: [2887.6, 2601.5, 3276.3, 3782.7, 3645.2, 2640.9, 2088.6, 1373.3, 896.5, 756.0, 436.4, 404.6, 285.5, 203.3, 182.4, 180.4, 158.5, 120.8, 120.1, 23.6, 11.6, 0.0]

},

]
}